export default "/048cb1f2b29308e18768c65cfd51e426596a830c/a2cdf02300b2663230f496dbfe02b4a0.svg";